import axios from 'axios';
import { UNAUTHORIZED } from 'http-status-codes';

import {
    LOGOUT,
    SET_CURRENT_USER_ERROR,
    UPDATE_COMPANY_SUCCESS,
    SET_CURRENT_USER_PENDING,
    SET_CURRENT_USER_SUCCESS,
} from 'store/actions';
import { store, persistor } from '../store';

const api = axios.create();
const baseURL = `${process.env.REACT_APP_CIRCLER_API_URL}/api`;

const handleLogout = async () => {
    const { dispatch } = store;

    try {
        dispatch(LOGOUT());
        dispatch(SET_CURRENT_USER_PENDING({ loading: true }));
        dispatch(SET_CURRENT_USER_SUCCESS(null));
        dispatch(UPDATE_COMPANY_SUCCESS(null));

        localStorage.clear();
        sessionStorage.clear();
        window.localStorage.clear();
        window.sessionStorage.clear();

        await persistor.purge();

        window.location.href = '/login';
    } catch (err) {
        dispatch(SET_CURRENT_USER_ERROR(err));
        console.error('Logout error:', err);
    }
};

let setIsLoading = false;
api.interceptors.request.use(
    (config) => {
        setIsLoading = true;

        const { token } = store.getState().auth;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        setIsLoading = false;
        return Promise.reject(error);
    },
);

api.interceptors.response.use(
    (response) => {
        setIsLoading = false;
        return response?.data || response;
    },
    async (err) => {
        setIsLoading = false;
        if (err.response?.status === UNAUTHORIZED && !err.config.url.includes('/user/login/')) {
            try {
                await handleLogout();
            } catch (logoutError) {
                console.error('Logout error:', logoutError);
            }
        }
        console.error(err);
        throw err;
    },
);

export const doGet = (url) => {
    return api.get(url, { baseURL });
};

export const doPost = (url, data) => {
    return api.post(url, data, {
        baseURL,
    });
};

export const doPut = (url, data) => {
    return api.put(url, data, {
        baseURL,
    });
};

export const doPatch = (url, data) => {
    return api.patch(url, data, {
        baseURL,
    });
};

export const doDelete = (url) => {
    return api.delete(url, { baseURL });
};

export const isLoading = () => setIsLoading;
